const pushDataLayerGTM = (category, action, label, additionalData = {}) => {
  let param = {
    event: 'event',
    eventCategory: `porto-plus:${category}`, // Geral, Login, Home, Detalhes da oferta, FAQ, Para Mim, Meus Pontos
    eventAction: '',
    eventLabel: '',
  }

  // Adiciona dados extras se fornecidos
  if (additionalData.partnerName) {
    param.partnerName = additionalData.partnerName
  }
  if (additionalData.partnerId) {
    param.partnerId = additionalData.partnerId
  }
  if (additionalData.campaignName) {
    param.campaignName = additionalData.campaignName
  }
  if (additionalData.position) {
    param.position = additionalData.position
  }
  if (additionalData.bannerId) {
    param.bannerId = additionalData.bannerId
  }
  if (additionalData.bannerTitle) {
    param.bannerTitle = additionalData.bannerTitle
  }

  if (category == 'geral' || category == 'mais-porto-seguro') {
    let pathname =
      window.location.pathname == '/' ? 'home' : window.location.pathname
    let nomeSecao = replaceSpecialChars(pathname).toLowerCase()
    let nomeItem = replaceSpecialChars(label).toLowerCase()

    param.eventAction = `${action}` // clique:[[local-item]]
    param.eventLabel = `${nomeSecao}:${nomeItem}`

    sendEventGTM(param)
  } else {
    param.eventAction = `${action}`
    param.eventLabel = `${label}`

    let index = label.indexOf(':')
    if (
      (action == 'clique:resgatar-meus-pontos' && index >= 0) ||
      (action == 'clique:menu-opcoes' && index >= 0) ||
      (action == 'clique:card' && index >= 0)
    ) {
      param.eventLabel = `${replaceSpecialChars(
        label.slice(0, index)
      ).toLowerCase()}:${replaceSpecialChars(label.slice(index)).toLowerCase()}`
    }

    if (category == '/faq/cartao' || category == '/faq/corretor') {
      param.eventCategory = `porto-plus:${replaceSpecialChars(
        category
      ).toLowerCase()}`
      if (index >= 0) {
        param.eventLabel = `${replaceSpecialChars(
          label.slice(0, index)
        ).toLowerCase()}:${replaceSpecialChars(
          label.slice(index)
        ).toLowerCase()}`
      }
    }

    sendEventGTM(param)
  }

  function replaceSpecialChars(str) {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .replace(/([^\w]+|\s+)/g, '-') // Substitui espaço e outros caracteres por hífen
      .replace(/\-\-+/g, '-') // Substitui multiplos hífens por um único hífen
      .replace(/(^-+|-+$)/, '') // Remove hífens extras do final ou do inicio da string
  }

  function sendEventGTM(param) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(param)
    // console.log(param)
  }
}

// Função auxiliar para obter nome do parceiro
const getPartnerName = (offerData) => {
  if (!offerData) return null
  
  // Prioridade de busca conforme especificação
  const partnerName = 
    offerData.redeemstore?.redeemstorephysical?.vendorName ||
    offerData.redeemstore?.redeemstoreonline?.vendorName ||
    offerData.vendorName ||
    offerData.partnerName

  if (partnerName) {
    return partnerName
  }

  // Fallback: se não existe nome mas existe partnerId
  if (offerData.partnerId && offerData.campaignName) {
    return `${offerData.partnerId}-${offerData.campaignName}`
  }

  return null
}

// Função auxiliar para obter ID do parceiro
const getPartnerId = (offerData) => {
  if (!offerData) return null
  
  // Prioridade de busca para ID do parceiro
  const partnerId = 
    offerData.redeemstore?.redeemstorephysical?.vendorId ||
    offerData.redeemstore?.redeemstoreonline?.vendorId ||
    offerData.vendorId ||
    offerData.partnerId ||
    offerData.id // Fallback para o ID da oferta como ID do parceiro

  return partnerId
}

export { getPartnerName, getPartnerId }
export default pushDataLayerGTM
